'use client'

import { useEffect } from 'react'
import { Button } from '@/components/ui/button'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    // Log the error to console for debugging
    console.error('Application error:', error)
  }, [error])

  return (
    <div className="flex min-h-screen flex-col items-center justify-center p-4">
      <div className="w-full max-w-md space-y-4 text-center">
        <h1 className="text-2xl font-bold text-red-600">Erro na Aplicação</h1>
        <p className="text-gray-600">
          Ocorreu um erro ao carregar a aplicação.
        </p>
        <div className="rounded-lg bg-red-50 p-4 text-left">
          <p className="text-sm font-mono text-red-800">
            {error.message || 'Erro desconhecido'}
          </p>
          {error.digest && (
            <p className="mt-2 text-xs text-gray-500">
              Digest: {error.digest}
            </p>
          )}
        </div>
        <div className="space-y-2">
          <Button onClick={reset} className="w-full">
            Tentar Novamente
          </Button>
          <Button
            variant="outline"
            onClick={() => (window.location.href = '/')}
            className="w-full"
          >
            Voltar ao Início
          </Button>
        </div>
      </div>
    </div>
  )
}



